import { Switch } from '@mantine/core';
import { useState } from 'react';
import classes from './Switch.module.css';
export const PrimeSwitch: React.FC = () => {
  const [checked, setChecked] = useState(false);
  return <Switch size="md" defaultChecked={false} checked={checked} onChange={event => setChecked(event.currentTarget.checked)} classNames={{
    track: classes.track,
    thumb: checked ? classes.thumbChecked : classes.thumb
  }} />;
};